import { Box, Center, Text, HStack, Image, VStack, SimpleGrid } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { StoreFrontContainer } from '../../components/LandingPageComponents/styles/HeaderStyles';
import ProductItemNew from 'components/Dashboard/ProductItemNew';
import useLocalSearch from 'hooks/useLocalSearch';
import SearchFilterInput from 'components/Dashboard/SearchFilterInput';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { get_products_by_category } from 'redux/actions/productActions';
import FilterComponent from 'components/Products/FilterComponent';
import { AdBannerComponent } from '../../pages/dashboard/components/AdBanner';
import { isEmpty } from 'lodash';
import { generateSubcategoriesArray, ITEMS_PER_PAGE } from 'utils/utils';
import ApiPagination from 'components/Dashboard/ApiPagination';
import useDebounce from 'hooks/useDebounce';
import CategoryCard from 'components/Dashboard/CategoryCard';
import emptyList from '../../assets/empty-list.png';
import Loader from 'components/loader';
const SingleCategory = () => {
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const [categoryDetails, setCategoryDetails] = useState(null);
    const [filters, setFilters] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const debouncedValue = useDebounce(searchTerm, 700);

    const {
        categories,
        productsByCategory: products,
        loading,
    } = useSelector((state) => state.productReducer);
    let { id } = useParams();
    useEffect(() => {
        if (id && !isEmpty(categories)) {
            const subCategories = generateSubcategoriesArray(categories);
            const allCategories = [...categories, ...subCategories];
            const categoryDet = allCategories?.find((x) => x.category_id === id);

            setCategoryDetails(categoryDet);
        }
    }, [id, categories]);

    const { onSearch, data } = useLocalSearch({
        payload: products?.items,
    });

    useEffect(() => {
        // dispatch(get_category_details(id));
        if (categoryDetails) {
            dispatch(
                get_products_by_category(id, categoryDetails.hasSubcategories, {
                    per_page: ITEMS_PER_PAGE,
                    page: page + 1,
                    name: debouncedValue,
                    ...filters,
                }),
            );
        }
    }, [dispatch, id, categoryDetails, page, debouncedValue, filters]);

    useEffect(() => {
        if (debouncedValue) {
            setPage(0);
        }
    }, [debouncedValue]);
    const handleFilter = (values) => {
        setFilters({
            price_sort: values.sliderValue,
            vendor_name: values.selectedVendors?.[0],
            brand: values.selectedBrands?.[0],
            stock_on_hand: values.stock_on_hand,
        });
    };

    return (
        <StoreFrontContainer>
            <Box mb="10">
                <Text fontSize="2xl" fontWeight="bold" textTransform={'capitalize'}>
                    {categoryDetails?.name.toLowerCase()}
                </Text>
            </Box>
            {/* <Box>
                <Image src={categoryDetails?.image || banner} w="auto" h="52" objectFit="cover" />
            </Box>{' '} */}
            <SearchFilterInput
                showFilter
                source={'single products'}
                onSearch={(e) => {
                    onSearch(e);
                    setSearchTerm(e);
                }}
                FilterButton={FilterComponent}
                handleFilter={handleFilter}
            />
            <AdBannerComponent />
            {loading ? (
                <Center mt="20">
                    <Loader fullscreen={false} />
                </Center>
            ) : (
                <>
                    {!isEmpty(categoryDetails?.sub_categories) && (
                        <Text fontWeight={'bold'} mt={3}>
                            Sub Categories
                        </Text>
                    )}
                    <HStack
                        w="100%"
                        gap={{ base: '5%', lg: '4px' }}
                        mx="auto"
                        mt="4"
                        mb="8"
                        justifyContent="flex-start"
                        overflowX={'auto'}
                        alignItems="start">
                        {categoryDetails?.sub_categories?.map((item) =>
                            item.status === 'active' ? <CategoryCard category={item} /> : null,
                        )}
                    </HStack>
                    {!isEmpty(data) ? (
                        <>
                            <Text fontWeight={'bold'} mt={3}>
                                Products
                            </Text>
                            <SimpleGrid
                                columns={{ base: 2, lg: 4 }}
                                gap={{ base: 4, lg: 6 }}
                                mx="auto"
                                mt="4"
                                mb="8">
                                {data?.map((item) => (
                                    <ProductItemNew item={item} key={item.item_id} />
                                ))}
                            </SimpleGrid>
                            <ApiPagination
                                page={page}
                                setPage={setPage}
                                hasMorePages={products?.page_context?.has_more_page}
                            />
                        </>
                    ) : (
                        <VStack h="55vh" justify="center">
                            <Image src={emptyList} />
                            <Text
                                w="200px"
                                textAlign="center"
                                fontWeight="600"
                                fontSize="17px"
                                lineHeight="16px"
                                pt="27px">
                                You do not have any products under this category
                            </Text>
                        </VStack>
                    )}
                </>
            )}
        </StoreFrontContainer>
    );
};

export default SingleCategory;
